import {MethodType, ParamsFetchType, GenerateUrlApiType, ResponseType} from 'src_common/browser/apiUtils';

import { GenerateUrlApiParamsType } from 'src_common/server/webDriver/sdkApiWebUtils';
import { openapi_mobile_app_version_update_putMobileAppUpdateVersion, ParamsType, decodeResponse200, Response200Type } from 'src/api_openapi/generated/openapi_mobile_app_version_update_putMobileAppUpdateVersion';

export type MobileUpdateVersionModelType = Response200Type;

const decode = (status: number, data: ResponseType): MobileUpdateVersionModelType => {
    if (status === 200 && data.type === 'json') {
        return decodeResponse200(data.json);
    }

    throw new Error(`unhandled response ${status} - ${data.type}`);
};

export interface MobileUpdateVersionTypeSubmitType {
    data: ParamsType['body'],
}

export const putCreateMobileUpdateVersion = {
    browser: {
        params: (params: MobileUpdateVersionTypeSubmitType): ParamsFetchType<MobileUpdateVersionTypeSubmitType> => {
            return {
                type: MethodType.POST,
                url: '/api-web/put-app-update-version',
                body: params
            };
        },
        decode: decode
    },
    express: {
        method: MethodType.POST,
        urlBrowser: '/api-web/put-app-update-version',
    },
    generateUrlApi: async (params: GenerateUrlApiParamsType<MobileUpdateVersionTypeSubmitType>): Promise<GenerateUrlApiType> => {

        if (params.userSessionId === null) {
            return {
                passToBackend: false,
                status: 403,
                responseBody: {
                    errorMessage: 'User id invalid',
                }
            };
        }

        const response = await openapi_mobile_app_version_update_putMobileAppUpdateVersion(params.API_URL, params.API_TIMEOUT, params.jwtToken, {
            universe: params.API_UNIVERSE,
            body: params.req.body.data
        });

        return {
            passToBackend: false,
            status: response.status,
            responseBody: response.body
        };
    }
};
